module.exports = __webpack_public_path__ + "static/logo-optimus-dm-0f2a6d2372452809f7f399a6706a1a37.png";